import { h } from 'preact';
import Section from 'components/bolt/section/section';
import s from 'components/bolt/iframe/iframe.sss';
import HTML from 'components/core/html/html.js';
import { joinClasses } from 'utils/utils';

export default class Iframe extends Section {
	constructor(props) {
		super(props);

		this.state = {
			loaded: false
		};

		this.handleLoaded = this.handleLoaded.bind(this);
	}

	get pageData() {
		const props = this.props;
		return props.data || props.appData?.pages?.[props.id]?.data || {};
	}

	get url() {
		return this.pageData.url;
	}

	componentDidMount() {
		super.componentDidMount();
	}

	handleLoaded() {
		this.setState({ loaded: true });
	}

	isDedicatedPage() {
		return !this.props.isSection;
	}

	getIframeStyle() {
		if (this.isDedicatedPage() || typeof window === 'undefined') {
			return {};
		}

		const size = this.pageData.size;
		let height = size.mobile?.height || 375;
		let width = size.mobile?.width || window.innerWidth;
		let maxWidth = 1200;

		// Is there a better way to handle this?
		if (window.innerWidth >= 1600) {
			height = size.largeDesktop?.height || 920;
			width = size.largeDesktop?.width || window.innerWidth;
			if (size.largeDesktop?.width > 1200) {
				maxWidth = 'none';
			}
		} else if (window.innerWidth >= 1280) {
			height = size.desktop?.height || 768;
			width = size.desktop?.width || window.innerWidth;
			if (size.desktop?.width > 1200) {
				maxWidth = 'none';
			}
		} else if (window.innerWidth >= 1024) {
			height = size.smallDesktop?.height || 600;
			width = size.smallDesktop?.width || window.innerWidth;
		} else if (window.innerHeight >= 768) {
			height = size.tablet?.height || 600;
			width = size.tablet?.width || window.innerWidth;
		}

		return {
			height: height + 'px',
			width: width + 'px',
			maxWidth
		};
	}

	renderHeading(heading) {
		return (
			<div class={s.heading} key="heading">
				<HTML class="h3" content={heading} markdown inline />
			</div>
		);
	}

	renderDescription(description) {
		return (
			<div class={s.description} key="description">
				<HTML class="xlarge" content={description} markdown />
			</div>
		);
	}

	renderIFrame() {
		return (
			<iframe
				style={this.getIframeStyle()}
				ref={ref => this.iframe = ref}
				src={this.url}
				onLoad={this.handleLoaded}
				allowFullscreen={this.pageData.allowFullscreen}
				key="iframe"
			/>
		);
	}

	render({ id, appData }, { loaded }) {
		const pageData = this.pageData;

		const dedicatedPage = this.isDedicatedPage();
		const footer = appData?.footer?.defaultFooter;
		const staticInlineFooter = dedicatedPage && footer?.position === 'static' && footer?.inline;

		const { title, description } = pageData;

		return (
			<div
				class={joinClasses(s.wrapper, staticInlineFooter && s.fullHeight, dedicatedPage ? s.dedicatedPage : s.section)}
				data-section={id}
			>
				{this.renderBgContent()}
				{!!title && this.renderHeading(title)}
				{!!description && this.renderDescription(description)}
				<div class={joinClasses(s.loader, loaded && s.hide)} key="loader">
					<div class={s.spinner} />
				</div>
				{this.renderIFrame()}
				{this.renderOverlayedContent()}
			</div>
		);
	}
}
